import React from "react";
import Marty from "marty";
//import { Link } from "react-router";

let Open = React.createClass({
    render() {
        return (
            <section className="eo-sub-view open">
                <h2>Open source compliance</h2>
                <ol>
                    <li>
                        <h3>eero iOS mobile app</h3>
                        <p><a href="/public/img/legal/iOS Attribution Notice.pdf.zip" target="_blank">iOS attribution notice</a></p>
                    </li>
                    <li>
                        <h3>eero Android mobile app</h3>
                        <p><a href="/public/img/legal/Android Attribution Notice.pdf.zip" target="_blank">Android attribution notice</a></p>
                    </li>
                    <li>
                        <h3>eero device</h3>
                        <p><a href="/public/img/legal/eero Device Attribution Notice.pdf.zip" target="_blank">eero device attribution notice</a></p>
                    </li>
                    <li>
                        <h3>Open source distribution</h3>
                        <p>The software included in this product contains copyrighted software that is licensed under the GPL. A copy of these licenses is included in the eero app's "Help" section under
                            the "Legal" subsection and on the eero website's "Legal" section under the header "Open source compliance" by clicking the “iOS attribution notice”, "Android attribution notice",
                            and "eero device attribution notice" links. You may obtain the complete corresponding source code from us for a period of three years after our last shipment of this product,
                            which will be no earlier than February 23, 2019, by sending a money order or check for $5 to: eero inc., ATTN: eero Legal Open Source Code Distribution, 500 Howard Street,
                            Suite 900, San Francisco, CA, 94105, USA. Please write “Source for eero device” in the memo line of your payment. You may also request a copy of the source by
                            e-mailing <a href="mailto:rlegal@eero.com<">legal@eero.com</a> with "Source for eero device" in the subject line. This offer is valid to anyone in receipt of this information.</p>
                    </li>
                </ol>
            </section>
        );
    },
    getInitialState() {
        return {};
    }
});

export default Marty.createContainer(Open, {});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/legal/views/open/Handler.js
 **/